import { css } from '@emotion/css'
import getThemeColors, { colors } from '../../themes'
import { hexToRgba } from '../../themes/helpers'

const styles = {
  button: css({
    appearance: 'none',
    borderRadius: '50%',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '&:focus': {
      outline: 'none',
    },

    '&[disabled]': {
      opacity: 0.3,
      pointerEvents: 'none',
    },
  }),
}

export default styles

export const buttonSize = size => {
  switch (size) {
    case 'extraSmall':
      return css({
        width: 16,
        height: 16,
      })

    case 'small':
      return css({
        width: 20,
        height: 20,
      })

    case 'medium':
      return css({
        width: 30,
        height: 30,
      })

    default:
      return css({
        width: 24,
        height: 24,
      })
  }
}

export const iconSize = size => {
  switch (size) {
    case 'extraSmall':
      return 10

    case 'small':
      return 12

    case 'medium':
      return 16

    default:
      return 14
  }
}

export const buttonTheme = theme => {
  const themed = getThemeColors(theme)
  return css({
    backgroundColor: themed.light,

    '&:hover': {
      backgroundColor: themed.base,

      '& svg': {
        color: colors.white,
      },
    },

    '&:focus': {
      boxShadow: `0 0 2px 2px ${hexToRgba(themed.base, 0.3)}`,
      backgroundColor: themed.base,

      '& svg': {
        color: colors.white,
      },
    },
  })
}

export const iconTheme = theme => {
  const themed = getThemeColors(theme)
  return themed.base
}
